import { Viewport } from "@deck.gl/core";
import { _Tileset2D as Tileset2D } from "@deck.gl/geo-layers";

// NOTE:
// This class extends Tileset2D and "monkey patckes" it to attempt to remove all
// of its default caching behavior.
// We don't want the DeckGL layer to cache anything because we cache our data
// elsewhere. Keeping our cache in sync with DeckGL isn't always possible nor
// desired...
//
export default class NoCacheTileset2D extends Tileset2D {
  private _previousFrameNumber?: number;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(opts: any) {
    super({
      ...opts,
      // NOTE: set the maxCacheSize to the smallest possible number so it'll
      // always overflow. This allows us to remove everything but the visible/
      // selected tiles from the cache by calling _resizeCache().
      maxCacheSize: 1,
    });
  }

  private customOnChange() {
    // NOTE: resize the cache on every change to ensure anything aside from the
    // selected/visible tiles is removed. Normally the cache is only resized
    // when inserting something new into it (which is more performant).. but we
    // don't want anything in that cache (unless it has to be there because it
    // is visible).
    //
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this._resizeCache();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  update(viewport: Viewport, { zRange, modelMatrix }: any) {
    const frameNumber = super.update(viewport, { zRange, modelMatrix });

    if (frameNumber !== this._previousFrameNumber) {
      this.customOnChange();
    }

    this._previousFrameNumber = frameNumber;

    return frameNumber;
  }
}
